var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.75H33.25C33.7141 1.75 34.1592 1.93437 34.4874 2.26256C34.8156 2.59075 35 3.03587 35 3.5V12.25C35 12.7141 34.8156 13.1592 34.4874 13.4874C34.1592 13.8156 33.7141 14 33.25 14H7C6.53587 14 6.09075 13.8156 5.76256 13.4874C5.43437 13.1592 5.25 12.7141 5.25 12.25V3.5C5.25 3.03587 5.43437 2.59075 5.76256 2.26256C6.09075 1.93437 6.53587 1.75 7 1.75Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.25 1.75H7C6.53587 1.75 6.09075 1.93437 5.76256 2.26256C5.43437 2.59075 5.25 3.03587 5.25 3.5V3.9375C5.25 3.47337 5.43437 3.02825 5.76256 2.70006C6.09075 2.37187 6.53587 2.1875 7 2.1875H33.25C33.7141 2.1875 34.1592 2.37187 34.4874 2.70006C34.8156 3.02825 35 3.47337 35 3.9375V3.5C35 3.03587 34.8156 2.59075 34.4874 2.26256C34.1592 1.93437 33.7141 1.75 33.25 1.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12.25H5.25C3.31975 12.25 1.75 13.8198 1.75 15.75V36.75C1.75 38.6803 3.31975 40.25 5.25 40.25H35C36.9302 40.25 38.5 38.6803 38.5 36.75V15.75C38.5 13.8198 36.9302 12.25 35 12.25Z",
    fill: "#BF6A1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35 39.8125H5.25C3.31975 39.8125 1.75 38.2428 1.75 36.3125V36.75C1.75 38.6803 3.31975 40.25 5.25 40.25H35C36.9302 40.25 38.5 38.6803 38.5 36.75V36.3125C38.5 38.2428 36.9302 39.8125 35 39.8125Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35 12.25H5.25C3.31975 12.25 1.75 13.8197 1.75 15.75V16.1875C1.75 14.2572 3.31975 12.6875 5.25 12.6875H35C36.9302 12.6875 38.5 14.2572 38.5 16.1875V15.75C38.5 13.8197 36.9302 12.25 35 12.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 21H31.7065C29.169 21 26.8363 22.7115 26.3515 25.2035C26.198 25.9662 26.2156 26.7535 26.4031 27.5086C26.5906 28.2637 26.9433 28.9678 27.4358 29.5701C27.9283 30.1724 28.5483 30.6579 29.2511 30.9916C29.9539 31.3254 30.722 31.499 31.5 31.5H38.5C38.9641 31.5 39.4093 31.3156 39.7375 30.9874C40.0656 30.6592 40.25 30.2141 40.25 29.75V22.75C40.25 22.2859 40.0656 21.8408 39.7375 21.5126C39.4093 21.1844 38.9641 21 38.5 21Z",
    fill: "#D58347"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.5823 31.0626H31.472C30.3313 31.0598 29.2211 30.6945 28.3016 30.0195C27.3822 29.3444 26.7011 28.3946 26.3568 27.3071C26.8608 29.6801 28.9783 31.5001 31.5 31.5001H38.5C38.9095 31.5058 39.3075 31.3648 39.622 31.1026C39.9366 30.8403 40.1469 30.4742 40.215 30.0704C39.935 30.6741 39.3015 31.0626 38.5823 31.0626Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 28C32.4665 28 33.25 27.2165 33.25 26.25C33.25 25.2835 32.4665 24.5 31.5 24.5C30.5335 24.5 29.75 25.2835 29.75 26.25C29.75 27.2165 30.5335 28 31.5 28Z",
    fill: "#F9C20A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 28C32.4665 28 33.25 27.2165 33.25 26.25C33.25 25.2835 32.4665 24.5 31.5 24.5C30.5335 24.5 29.75 25.2835 29.75 26.25C29.75 27.2165 30.5335 28 31.5 28Z",
    fill: "url(#paint0_linear_145_7077)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.5823 21.4375H31.472C30.3342 21.4347 29.225 21.7946 28.3056 22.4648C27.3861 23.1351 26.7041 24.0809 26.3585 25.165C26.8135 22.7098 29.2355 21 31.5 21H38.5C39.3663 21 40.075 21.6038 40.215 22.4298C39.935 21.826 39.3015 21.4375 38.5823 21.4375Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30.156L37.2505 39.4083C38.01 38.7625 38.5 37.8175 38.5 36.75V31.5H31.5C30.1648 31.5 28.9275 30.9803 28 30.156Z",
    fill: "url(#paint1_linear_145_7077)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.25H35V10.5H5.25V5.25Z",
    fill: "#303C42"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M5.25 5.25H35V7.875H5.25V5.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_7077",
    x1: 29.9145,
    y1: 25.5098,
    x2: 33.0855,
    y2: 26.9903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_145_7077",
    x1: 30.779,
    y1: 28.357,
    x2: 38.1097,
    y2: 35.6878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0.02
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.364e987821592c080abbdea94f34ea73.svg";
export { ForwardRef as ReactComponent };